import { getIntl } from "context/SettingsProvider";
import * as yup from "yup";

export const CreateEventValidationSchema = () => {
  const intl = getIntl();

  return yup.object({
    category: yup
      .object()
      .nullable()
      .test({
        name: "required",
        message: intl.formatMessage({ id: "createEvent.categoryRequired" }),
        test: (value) => !!value?.id,
      }),
    description: yup
      .string()
      .required(intl.formatMessage({ id: "createEvent.descriptionRequired" })),
    eventStartDate: yup
      .date()
      .nullable()
      .required(intl.formatMessage({ id: "createEvent.startDateRequired" })),
    eventEndDate: yup
      .date()
      .nullable()
      .required(intl.formatMessage({ id: "createEvent.endDateRequired" }))
      .min(yup.ref("eventStartDate"), intl.formatMessage({ id: "createEvent.endDateAfterStartDate" })),
  });
};

export default CreateEventValidationSchema;